import { Component, EventEmitter, OnInit, Output } from '@angular/core';

import { RxComposite } from '../model/rx-composite';
import { debounceTime, map, tap } from 'rxjs/operators';
import { BehaviorSubject, Observable, combineLatest } from 'rxjs';
import { RxSearchModule } from '@nrwl/rx-ui';
import { RxListModule } from '@nrwl/rx-list';
import { CommonModule } from '@angular/common';
import { ProgressSpinnerComponent } from '../progress-spinner/progress-spinner.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { RxNoDataModule } from '@nrwl/rx-no-data';

@Component({
  selector: 'rx-list-composite',
  templateUrl: './rx-list-composite.component.html',
  styleUrls: ['./rx-list-composite.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    RxNoDataModule,
    RxSearchModule,
    RxListModule,
    ScrollingModule,
    ProgressSpinnerComponent,
  ],
})
export class RxListCompositeComponent extends RxComposite implements OnInit {
  public keyword: string | any = '';
  private keywordSubject = new BehaviorSubject<string>(this.keyword);
  public filteredItems$: Observable<any[]>;
  @Output() enterKeyPressed = new EventEmitter<void>();

  constructor() {
    super();
  }

  ngOnInit() {
    this.filteredItems$ = combineLatest([
      this.payload.items$,
      this.keywordSubject.asObservable().pipe(debounceTime(300)),
    ] as [Observable<any[]>, Observable<string>]).pipe(
      map(([items, keyword]: [any[], string]) => {
        const keywordLower: string = keyword.toLowerCase();

        const filteredItems: any[] = items?.filter(
          (item) =>
            item.name.toLowerCase().startsWith(keywordLower) ||
            item.name.toLowerCase().includes(keywordLower),
        );

        return filteredItems.sort((a: any, b: any) => {
          const aNameLower = a.name.toLowerCase();
          const bNameLower = b.name.toLowerCase();
          const startsWithA = aNameLower.startsWith(keywordLower) ? -1 : 0;
          const startsWithB = bNameLower.startsWith(keywordLower) ? -1 : 0;
          return startsWithA - startsWithB;
        });
      }),
      tap((items: any[]) => {
        if (items.length > 0) {
          this.selectItem(items[0]);
        } else {
          this.selectItem(null);
        }
      }),
    );
  }

  ngOnDestroy(): void {}

  onEnterKeyPressed() {
    if (this.dialog?.dialogRef && this.isValid()) {
      this.dialog.dialogRef.close(this.payload);
    }
    this.enterKeyPressed.emit();
  }

  onKeywordChange(newKeyword: string) {
    this.keywordSubject.next(newKeyword);
  }

  selectItem(selected) {
    this.payload.selectedItem = selected;
  }

  override isValid() {
    return !!this.payload.selectedItem;
  }
}
